import { render, staticRenderFns } from "./color-picker.vue?vue&type=template&id=946b77d8&scoped=true"
import script from "./color-picker.vue?vue&type=script&lang=js"
export * from "./color-picker.vue?vue&type=script&lang=js"
import style0 from "./color-picker.vue?vue&type=style&index=0&id=946b77d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946b77d8",
  null
  
)

export default component.exports